<template>
  <FlashNotifications ref="flash" />

  <div class="flex flex-col items-center justify-center py-24 text-center px-4">
    <div class="w-16 h-16 rounded-2xl bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center mb-5">
      <svg class="w-7 h-7 text-blue-500 dark:text-blue-400" fill="none" stroke="currentColor" stroke-width="1.75" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5" />
      </svg>
    </div>
    <h3 class="text-base font-semibold text-gray-900 dark:text-white">Developer tools</h3>
    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1.5 max-w-sm">
      API keys and developer tools for organizations are coming soon.
    </p>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import FlashNotifications from 'controllers/vue_components/flash_toast'

const flash = ref(null)
</script>
